import React from "react";
import "../styles/login.css";

function SetupRequired() {
  return (
    <div className="login-screen">
      <div className="login-brand-panel">
        <div className="brand-mark">
          <span className="brand-name">CLOUD TECHON</span>
        </div>
        <div className="brand-copy">
          <h1>Setup required</h1>
          <p>Your Entra ID App Registration values have not been added yet.</p>
        </div>
      </div>
      <div className="login-form-panel">
        <div className="login-card" style={{ textAlign: "left" }}>
          <h2 className="login-heading">Configuration needed</h2>
          <p className="login-subheading">
            Create a <code>.env</code> file in the project root:
          </p>
          <pre style={{
            background: "#0f1424",
            color: "#e6e8f0",
            padding: "16px",
            borderRadius: "8px",
            fontSize: "12.5px",
            overflowX: "auto",
            marginBottom: "16px",
          }}>
{`cp .env.example .env`}
          </pre>
          <ul style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.8, paddingLeft: 18, marginBottom: 16 }}>
            <li><code>REACT_APP_CLIENT_ID</code> - Application (client) ID</li>
            <li><code>REACT_APP_TENANT_ID</code> - Directory (tenant) ID</li>
            <li><code>REACT_APP_REDIRECT_URI</code> - http://localhost:3000</li>
          </ul>
          <p style={{ fontSize: 12, color: "#6b7280" }}>
            After saving .env, restart <code>npm start</code>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default SetupRequired;
